import { ReactNode, createContext, useContext, useState } from 'react';
import { ArrayOfEmailAdresses } from '../../types/apimodel';


interface LandingProviderProps {
    children: ReactNode;
}


export type LandingContextInterface ={
    vorname: string,
    setVorname: (value: string) => void,
    nachname: string,
    setNachname: (value: string) => void,
    plz: string,
    setPlz: (value: string) => void,
    vsnr: string,
    setVsnr: (value: string) => void,
    arrayOfEmailAdresses: ArrayOfEmailAdresses,
    setArrayOfEmailAdresses: (value: ArrayOfEmailAdresses) => void,
    emailchoosen:  string,
    setEmailchoosen: (value: string) => void,
}



const defaultContextValue: LandingContextInterface = {
    vorname: "",
    setVorname: (value: string) => {},
    nachname: "",
    setNachname: (value: string)=> {},
    plz: "",
    setPlz: (value: string) => {},
    vsnr: "",
    setVsnr: (value: string)=> {},
    arrayOfEmailAdresses: null,
    setArrayOfEmailAdresses: (value: ArrayOfEmailAdresses)=> {},
    emailchoosen: "",
    setEmailchoosen: (value: string)=> {},
};

export const LandingContext = createContext<LandingContextInterface>(defaultContextValue);

// Erstelle den Provider
const LandingProvider: React.FC<LandingProviderProps> = ({ children }) => {
    const [vorname, setVorname] = useState<string>("");
    const [nachname, setNachname] = useState<string>("");
    const [plz, setPlz] = useState<string>("");
    const [vsnr, setVsnr] = useState<string>("");
    const [emailchoosen, setEmailchoosen] = useState<string>("");
    const [arrayOfEmailAdresses, setArrayOfEmailAdresses] = useState<ArrayOfEmailAdresses>({ value: [] });


    const value = {
        vorname,
        setVorname,
        nachname,
        setNachname,
        plz,
        setPlz,
        vsnr,
        setVsnr,
        arrayOfEmailAdresses,
        setArrayOfEmailAdresses,
        emailchoosen,
        setEmailchoosen
      };

    return (
        <LandingContext.Provider value={value}>
            {children}
        </LandingContext.Provider>
    );
};

export const useLandingContext = () => {
    const context = useContext(LandingContext);
    if (!context) {
      throw new Error('LandingContext must be used within a LandingProvider');
    }
    return context;
  };

export default LandingProvider;